import * as yup from 'yup'
import {
  REQUIRED_FIELD,
  REQUIRED_DOCUMENT,
  REQUIRED_INCOME,
  ERROR_DOCUMENT_UPLOADING,
  ERROR_ACCEPT_DATA_USAGE,
} from './../constants'

export default yup.object({
  contacts: yup
    .array(
      yup.object({
        firstname: yup.string().required(REQUIRED_FIELD),
        lastname: yup.string().required(REQUIRED_FIELD),
        hasReleventIncome: yup.boolean(),
        income: yup.array().when('shouldValidateDocuments', {
          is: true,
          then: yup
            .array()
            .min(1, REQUIRED_INCOME)
            .of(
              yup.object({
                handOff: yup.boolean(),
                documents: yup
                  .array()
                  .when(['handOff', '$isBrusselsZip'], {
                    is: (handOff, isBrusselsZip) => (handOff === false || handOff === undefined) && !isBrusselsZip,
                    then: yup
                      .array()
                      .min(1, REQUIRED_DOCUMENT)
                      .required(REQUIRED_DOCUMENT),
                  })
                  .test('isPresent', ERROR_DOCUMENT_UPLOADING, val => {
                    const uploadingFiles = (val && val.filter(file => file && file.isUploading !== undefined)) || 0
                    return !uploadingFiles.length
                  }),
              }),
            ),
        }),
      }),
    )
    .transform(contacts => {
      return contacts.map(contact => {
        return contact.income.length > 0
          ? { ...contact, shouldValidateDocuments: true }
          : { ...contact, shouldValidateDocuments: false }
        // isNotEmtpyOwner(owner) || (index === 0 && filledInOwners.length === 0) ? { ...owner, validate: true } : { validate: false },
      })
    }),
  acceptDataUsages: yup.boolean().when(['inModal', 'isGeneralStep'], {
    is: (inModal, isGeneralStep) => {
      return inModal === undefined && isGeneralStep === undefined ? false : !inModal && !isGeneralStep
    },
    then: yup
      .boolean()
      .required(ERROR_ACCEPT_DATA_USAGE)
      .oneOf([true], ERROR_ACCEPT_DATA_USAGE),
  }),
})



// WEBPACK FOOTER //
// ./src/utils/validation/schemas/documentsSchema.js